import { render, staticRenderFns } from "./HomeActionCard.vue?vue&type=template&id=3bf4aa6f&scoped=true&"
import script from "./HomeActionCard.vue?vue&type=script&lang=js&"
export * from "./HomeActionCard.vue?vue&type=script&lang=js&"
import style0 from "./HomeActionCard.vue?vue&type=style&index=0&id=3bf4aa6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf4aa6f",
  null
  
)

export default component.exports